import { isPast, isValid } from 'date-fns'
import moment from 'moment'
import store from 'store'
import { HttpClient } from '@opallabs/api'
import { getNestedProperty } from '@opallabs/lambda'
import loginError from '../loginError'
import setAccessToken from '../setAccessToken'

const getAccessToken = () =>
  HttpClient()
    .get('/upgrade_to_api_token')
    .then((response) => {
      const expiration = moment(
        getNestedProperty(response, 'data', 'expires_at')
      )
      if (moment().isAfter(expiration)) {
        throw new Error('Access token is expired')
      }
      return response
    })

const handleAccessToken = (dispatch) => (response) => {
  if (response && response.data) {
    return dispatch(
      setAccessToken(
        {
          expiresAt: response.data && response.data.expires_at,
          token: response.data.token,
        },
        dispatch
      )
    )
  }
  return false
}

const handleError = (dispatch) => (err) => dispatch(loginError(err))

const getToken = () => (dispatch) => {
  const currentToken = store.get('accessToken')
  const expiry = store.get('accessTokenExpires')
  const expiryDate = new Date(expiry)
  const expired = !isValid(expiryDate) || isPast(expiryDate)

  if (!expired && currentToken !== undefined) {
    handleAccessToken(dispatch)({
      data: {
        token: currentToken,
        expires_at: expiry,
      },
    })
    return
  }

  return getAccessToken()
    .then(handleAccessToken(dispatch))
    .catch(handleError(dispatch))
}

export default getToken
